export enum TestIds {
  AccessKey = 'accessKey',
  AccountName = 'accountName',
  BucketName = 'bucketName',
  ContainerName = 'containerName',
  EndDate = 'endDate',
  EntraClientId = 'entraClientId',
  EntraSecretValue = 'entraSecretValue',
  EntraTenantId = 'entraTenantId',
  Frequency = 'frequency',
  Hostname = 'hostname',
  Password = 'password',
  Port = 'port',
  S3Folder = 's3Folder',
  SasToken = 'sasToken',
  SecretAccessKey = 'secretAccessKey',
  SftpFolder = 'sftpFolder',
  SharePointDriveId = 'sharePointDriveId',
  SharePointSiteId = 'sharePointSiteId',
  SPFolder = 'spFolder',
  StartDate = 'startDate',
  StorageType = 'storageType',
  Username = 'username',
}
